import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule, MatTableDataSource } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatDialogModule, MatDialog } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSnackBarModule, MatSnackBar } from '@angular/material/snack-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../../api/services/auth.service';
import { HeaderNavComponent } from 'src/app/ui/header-nav/header-nav.component';
import { FooterComponent } from 'src/app/ui/footer/footer.component';

@Component({
  selector: 'app-admin-dashboard',
  standalone: true,
  imports: [
    CommonModule, MatCardModule, MatButtonModule, MatIconModule, MatTableModule,
    MatTabsModule, MatDialogModule, MatFormFieldModule, MatInputModule,
    MatSnackBarModule, MatProgressSpinnerModule, FormsModule,
    HeaderNavComponent, FooterComponent
  ],
  templateUrl: './admin-dashboard.component.html'
})
export class AdminDashboardComponent implements OnInit {
  selectedTabIndex = 0;
  isLoading = false;

  pendingBars: any[] = [];
  approvedBars: any[] = [];
  rejectedBars: any[] = [];
  selectedBar: any = null;
  rejectReason = '';
  showRejectDialog = false;
  barToReject: any = null;

  pendingDataSource = new MatTableDataSource<any>();
  approvedDataSource = new MatTableDataSource<any>();
  rejectedDataSource = new MatTableDataSource<any>();
  displayedColumns = ['barName', 'ownerName', 'city', 'licenseNumber', 'createdAt', 'actions'];

  constructor(
    private authService: AuthService,
    private snackBar: MatSnackBar,
    private router: Router,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.loadAllBars();
  }

  loadAllBars(): void {
    this.isLoading = true;
    this.authService.getPendingBars().subscribe({
      next: (bars) => {
        this.pendingBars = bars;
        this.pendingDataSource.data = bars;
      },
      error: () => {}
    });
    this.authService.getApprovedBars().subscribe({
      next: (bars) => {
        this.approvedBars = bars;
        this.approvedDataSource.data = bars;
        this.isLoading = false;
      },
      error: () => this.isLoading = false
    });
    this.authService.getRejectedBars().subscribe({
      next: (bars) => {
        this.rejectedBars = bars;
        this.rejectedDataSource.data = bars;
      },
      error: () => {}
    });
  }

  viewBarDetails(barId: string): void {
    this.authService.getBarDetails(barId).subscribe({
      next: (bar) => this.selectedBar = bar,
      error: () => this.snackBar.open('Failed to load bar details', 'Close', { duration: 3000 })
    });
  }

  approveBar(barId: string): void {
    this.authService.approveBar(barId).subscribe({
      next: () => {
        this.snackBar.open('Bar approved successfully', 'Close', { duration: 3000 });
        this.loadAllBars();
        this.selectedBar = null;
      },
      error: () => this.snackBar.open('Failed to approve bar', 'Close', { duration: 3000 })
    });
  }

  openRejectDialog(bar: any): void {
    this.barToReject = bar;
    this.rejectReason = '';
    this.showRejectDialog = true;
  }

  closeRejectDialog(): void {
    this.showRejectDialog = false;
    this.barToReject = null;
    this.rejectReason = '';
  }

  confirmReject(): void {
    if (!this.barToReject || !this.rejectReason.trim()) {
      this.snackBar.open('Please provide a rejection reason', 'Close', { duration: 3000 });
      return;
    }
    this.authService.rejectBar(this.barToReject.id, this.rejectReason).subscribe({
      next: () => {
        this.snackBar.open('Bar rejected', 'Close', { duration: 3000 });
        this.closeRejectDialog();
        this.loadAllBars();
        this.selectedBar = null;
      },
      error: () => this.snackBar.open('Failed to reject bar', 'Close', { duration: 3000 })
    });
  }

  onTabChange(event: any): void {
    this.selectedTabIndex = event.index;
  }

  onBack(): void {
    this.router.navigate(['/service-provider']);
  }
}
